import { MessageSystem } from '@halo/ui-chat-react';
import { MsgItem } from '../../msg-parts';
import type { MsgGroupCreateContentProps } from './msg-group-create-content';
import { MsgGroupCreateContent } from './msg-group-create-content';

export interface MsgGroupCreateProps extends MsgGroupCreateContentProps {}

export const MsgGroupCreate = memo(function MsgGroupCreate({ message }: MsgGroupCreateProps) {
  return (
    <MsgItem message={message}>
      <MessageSystem>
        <MsgGroupCreateContent message={message} />
      </MessageSystem>
    </MsgItem>
  );
});
